var _mask, _path, _path2, _path3, _mask2, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2081_8836",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0698 21L21.3198 9.75L10.0698 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0698 21L21.3198 9.75L10.0698 21Z",
    fill: "#76808D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7769 21.7071L22.0269 10.4571L20.6127 9.04289L9.36272 20.2929L10.7769 21.7071ZM20.6127 9.04289L9.36272 20.2929L10.7769 21.7071L22.0269 10.4571L20.6127 9.04289Z",
    fill: "#76808D",
    mask: "url(#path-1-inside-1_2081_8836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0698 21L21.3198 9.75",
    stroke: "#76808D",
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_2081_8836",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3198 21L10.0698 9.75L21.3198 21Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3198 21L10.0698 9.75L21.3198 21Z",
    fill: "#76808D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0269 20.2929L10.7769 9.04289L9.36272 10.4571L20.6127 21.7071L22.0269 20.2929ZM9.36272 10.4571L20.6127 21.7071L22.0269 20.2929L10.7769 9.04289L9.36272 10.4571Z",
    fill: "#76808D",
    mask: "url(#path-4-inside-2_2081_8836)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3198 21L10.0698 9.75",
    stroke: "#76808D",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.d61bda5fde7891ac1009ef734dba0223.svg";
export { ForwardRef as ReactComponent };